import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { enquiryInfo } from "./enquiry-management-response-model";

export class EnQuiryManagementResponse extends GlobalResponseObject{
    data?: enquiryInfo[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: enquiryInfo[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}